import { useEffect } from 'react';

import { dispatchWidgetsView } from 'adapter/in/dashboards/context/Widgets/view';

export const AUTO_REFRESH_TIME = 15 * 60 * 1000;

const useAutorefreshDashboard = (): void => {
    const { toggleReloadWidgets } = dispatchWidgetsView();

    let interval: NodeJS.Timeout;

    useEffect(() => {
        interval = setInterval(() => {
            toggleReloadWidgets(true);
        }, AUTO_REFRESH_TIME);

        return () => {
            clearInterval(interval);
        };
    }, []);
};

export default useAutorefreshDashboard;
